"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderMessagesFragment = exports.orderDetailFragment = exports.orderPriceFragment = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const checkout_1 = require("./checkout");
exports.orderPriceFragment = (0, graphql_tag_1.default) `
  fragment OrderPrice on TaxedMoney {
    gross {
      amount
      currency
    }
    net {
      amount
      currency
    }
  }
`;
exports.orderDetailFragment = (0, graphql_tag_1.default) `
  ${exports.orderPriceFragment}
  ${checkout_1.checkoutAddressFragment}
  ${checkout_1.checkoutProductVariantFragment}
  fragment OrderDetail on Order {
    userEmail
    paymentStatus
    paymentStatusDisplay
    status
    statusDisplay
    id
    token
    number
    shippingAddress {
      ...Address
    }
    reservations {
      rentalStartDate
      rentalEndDate
    }
    lines {
      productName
      quantity
      variant {
        ...ProductVariant
      }
      unitPrice {
        currency
        ...OrderPrice
      }
      totalPrice {
        currency
        ...OrderPrice
      }
      returnAddress {
        ...Address
      }
      lender {
        user {
          firstName
        }
      }
      undiscountedUnitPrice {
        currency
        ...OrderPrice
      }
    }
    fulfillments {
      trackingNumber
      lines {
        orderLine {
          id
        }
      }
    }
    shippingMethodName
    subtotal {
      currency
      ...OrderPrice
    }
    total {
      ...OrderPrice
    }
    shippingPrice {
      ...OrderPrice
    }
    discounts {
      amount {
        currency
        amount
      }
    }
    orderTransactions {
      borrowerFees {
        due {
          amount
          currency
        }
      }
    }
    undiscountedTotal {
      currency
      ...OrderPrice
    }
  }
`;
exports.orderMessagesFragment = (0, graphql_tag_1.default) `
  fragment OrderMessagesFragment on Order {
    messages {
      id
      author {
        id
        firstName
        avatar {
          url
        }
      }
      messageBody
      sent
      archived
      read
    }
  }
`;
//# sourceMappingURL=order.js.map